// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__vXDFP","emails":"CreateEditClinics_emails__24uRN","emailTagLabel":"CreateEditClinics_emailTagLabel__lMMl4"};